import { render } from "./selectCallMobileModal.vue?vue&type=template&id=4bc1c322&ts=true"
import script from "./selectCallMobileModal.vue?vue&type=script&lang=ts"
export * from "./selectCallMobileModal.vue?vue&type=script&lang=ts"

import "./selectCallMobileModal.vue?vue&type=style&index=0&id=4bc1c322&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__